<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
    class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal" v-esc="escape">
    <div class="w-full" @keyup.enter="submitData">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "Yeni Birim" : "Birim Düzenle" }}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>
      <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
        <form data-vv-scope="form-1">
          <div class="px-6 pt-6">

            <vs-input id="name" name="İsim" v-validate="'required|min:2|max:40'" v-model="newUnit.name" class="w-full"
              icon-pack="feather" icon="icon-user" label-placeholder="Birim İsmi" />
            <span class="text-danger text-sm"
              v-show="errors.has('form-1.İsim')">{{ errors.first('form-1.İsim') }}</span>

            <vs-input id="shortName" name="Kısa İsim" v-model="newUnit.shortName" class="w-full" icon-pack="feather"
              icon="icon-user" label-placeholder="Kısa İsmi" />

            <v-select :disabled="unitNameList.length == 0" id="originUnit" name="Ana Birim"
              v-model="newUnit.originUnitId" itemid="id" label="name" placeholder="Ana Birim Seçimi.."
              :options="unitNameList" class="mt-4" :reduce="unit=>unit.id" :clearable="true">
            </v-select>

            <vs-input id="originUnitQuantity" name="Ana Birim Oran" v-if="newUnit.originUnitId"
              v-validate="{required:true,regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}" v-model="newUnit.originUnitQuantity"
              class="w-full" icon-pack="feather" icon="icon-user" label-placeholder="Ana Birim Oranı" />
            <span class="text-danger text-sm" v-if="newUnit.originUnitId"
              v-show="errors.has('form-1.Ana Birim Oran')">{{ errors.first('form-1.Ana Birim Oran') }}</span>

          </div>
        </form>
        <div class="flex mt-5 px-6 pb-4">
          <vs-button class="mr-auto" type="gradient" color="danger" @click="isSidebarActiveLocal = false">
            Vazgeç
          </vs-button>
          <vs-button class="ml-auto" color="success" @click="submitData">Kaydet</vs-button>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import {
    createNewUnit,
    updateUnit,
    getUnitNameList
  } from '@/api/Unit';
  export default {
    props: {
      isSidebarActive: {
        type: Boolean,
        required: true
      },
      data: {
        type: Object,
        default: () => {},
      }
    },
    data() {
      return {
        newUnit: {},
        unitNameList: [],
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
        },
      }
    },
    computed: {
      isSidebarActiveLocal: {
        get() {
          return this.isSidebarActive
        },
        set(val) {
          if (!val) {
            this.$emit('closeSidebar')
            this.$validator.reset()
            this.initValues()
          }
        }
      }
    },
    methods: {
      escape(){
        if(this.isSidebarActiveLocal == true) this.isSidebarActiveLocal = false;
      },
      getUnitNameList: function () {
        getUnitNameList().then(res => {
          if (res && res.status === 200) this.unitNameList = res.data
          else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Ana Birimler Yüklenemedi !'
            });
          }
        }).catch(error => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantısı Başarısız !'
          });
        });
      },
      initValues: function () {
        this.newUnit = {};
      },
      submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll('form-1');
        if (checker) {
          this.newUnit.originUnitQuantity = this.newUnit.originUnitQuantity ? parseFloat(this.newUnit.originUnitQuantity) : null;
          if (this.newUnit.id) {
            updateUnit(this.newUnit).then(res => {
              if (res && res.status === 200) {
                this.$store.dispatch("unit/updateUnit", res.data).then(data => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Birim Güncelleme İşlemi Başarılı !'
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Birim Güncelleme İşlemi Başarısız !'
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası !'
              });
            });
          } else {
            this.newUnit.id = 0;
            createNewUnit(this.newUnit).then(res => {
              if (res && res.status === 200) {
                this.$store.dispatch("unit/addUnit", res.data).then(data => {
                  this.$vs.notify({
                    color: 'success',
                    title: 'Başarılı !',
                    text: 'Birim Ekleme İşlemi Başarılı !'
                  });
                  this.$emit('closeSidebar');
                  this.initValues();
                  this.$validator.reset();
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Birim Ekleme İşlemi Başarısız ! '
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucu Bağlantı Hatası ! '
              });
            });
          }
        }
      },
      mapNewUnit: async function () {
        //map
      },
    },
    components: {
      VuePerfectScrollbar
    },
    watch: {
      isSidebarActive: function (val) {
        if (!val) return
        if (Object.entries(this.data).length === 0) {
          this.initValues();
          this.$validator.reset();
        } else {
          this.newUnit = _.cloneDeep(this.data);
        }
      }
    },
    mounted: function () {
      this.getUnitNameList();
    },
    created: async function () {
    }
  }

</script>

<style lang="scss" scoped>
  .style-chooser .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: red;
    text-transform: lowercase;
    font-variant: small-caps;
  }

  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .tabPager {
    background-color: darkgreen;
    border-radius: 50%;
  }

</style>
